import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=541a6cb2&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"
import style1 from "./swiper.vue?vue&type=style&index=1&id=541a6cb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541a6cb2",
  null
  
)

export default component.exports